import {
  Animated,
  ImageBackground,
  Image,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
  Platform,
} from "react-native";
import { i18nLoadRequest } from "../../../store/i18n/i18nActions";
import LS from "../../../utils/localStorageUtils";
import i18n from "../../../i18n/i18n";
import EnFlag from "../../../assets/buttonsByLanguage/flags/en_flag.png";
import BgFlag from "../../../assets/buttonsByLanguage/flags/bg_flag.png";
import FrFlag from "../../../assets/buttonsByLanguage/flags/fr_flag.png";
import RuFlag from "../../../assets/buttonsByLanguage/flags/ru_flag.png";
import TrFlag from "../../../assets/buttonsByLanguage/flags/tr_flag.png";
import { useEffect, useRef, useState } from "react";
import {
  BtnSidebarClosePng,
  InputField,
  GoogleBtn,
  LoginBackground,
  LoginTitle,
  Login,
  LoginBckgd,
  // LoginLogoEn,
  LogoStatic,
  ArrowDownPng,
  LanguageCaret,
  LanguageCaretUp,
  FacebookLogin,
} from "../../../assets";
import FacebookButton from "../../../assets/login/FacebookButton.png";
import GoogleButton from "../../../assets/login/GoogleButton.png";
import SvaraModal from "../Modals/SvaraModal";

import { useDevice } from "../../../utils/hooks/useDevice";
import { RenderToggle } from "./RenderToggle";
import {
  loginRequest,
  googleLoginRequest,
  facebookLoginRequest,
} from "../../../store/auth/authActions";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useAPIAuthRequest } from "../../../services/api";
import LoginLogoWeb from "../Animations/LoginLogoWeb";
import { useTranslation } from "react-i18next";
import { LanguagePicker } from "../common/LanguagePicker";
type LoginIdentity = "username" | "phone";
type LoginAlert = { type: "error" | "success"; message: string };

type ILoginPlayer = {
  username: string;
  mobileNumber: string;
  password: string;
};

type LoginErrors = {
  username?: string;
  mobileNumber?: string;
  password?: string;
};

const languages = [
  { code: "en", id: 1, label: "English" },
  { code: "bg", id: 2, label: "Български" },
  { code: "fr", id: 3, label: "Français" },
  { code: "ru", id: 4, label: "Русский" },
  { code: "tr", id: 5, label: "Türkçe" },
];

const languageFlags: Record<string, any> = {
  en: EnFlag,
  bg: BgFlag,
  fr: FrFlag,
  ru: RuFlag,
  tr: TrFlag,
};

type IAuthModalProps = {
  modifyModal?: (name: string) => void;
};
interface IProps {
  onClose: () => void;
  data: ILoginPlayer;
  errors: LoginErrors;
  onSave: () => void;
  onChange: (name: keyof ILoginPlayer, value: string) => void;
  identity: LoginIdentity;
  loading: boolean;
  setIdentity: (i: LoginIdentity) => void;
  setAlert: (alert: LoginAlert) => void;
  onSuccess: (token: string) => void;
  showCloseIcon?: boolean;
}

function LoginModal({
  onClose,
  data,
  errors,
  onChange,
  identity,
  loading,
  showCloseIcon = true,
}: IProps) {
  const opacity = useRef(new Animated.Value(0)).current;
  const { isDesktop } = useDevice();
  const { t } = useTranslation();
  const [sound, setSound] = useState(true);
  const [emailNotif, setEmailNotif] = useState(false);
  const [notifications, setNotifications] = useState(true);
  const [lowQuality, setLowQuality] = useState(false);
  const [handMeter, setHandMeter] = useState(false);
  const [facebook, setFacebook] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const [isFocusedPass, setIsFocusedPass] = useState(false);
  const { AuthRequestToApi } = useAPIAuthRequest();

  const googleLabel = t("T_SITE_LOGIN_LOGIN_G");
  const googleParts = googleLabel.split(/<br\s*\/?>/i);
  const labelFb = t("T_SITE_LOGIN_LOGIN_FB");
  const partsFb = labelFb.split(/<br\s*\/?>/i);

  // ⬇️ redux bindings
  const dispatch = useDispatch();
  const langCode = useSelector((s: RootState) => s.i18n?.langCode ?? "en");
  const authLoading = useSelector((s: RootState) => s.auth.loading);

  const handleChangeLanguage = (code: string) => {
    i18n.changeLanguage(code).catch(() => {});
    LS.set("lang", code);

    const lang = languages.find((l) => l.code === code);
    if (lang) {
      dispatch(i18nLoadRequest({ langId: lang.id, langCode: lang.code }));
    } else {
      console.warn("[LoginModal] language not found in list:", code);
    }
  };

  const authState = useSelector((s: RootState) => s.auth);
  const authError = useSelector((s: RootState) => s.auth.error);
  const token = useSelector((s: RootState) => s.auth.token);

  useEffect(() => {
    console.log("AUTH STATE:", authState);
  }, [authState]);

  useEffect(() => {
    if (token) onClose();
  }, [token, onClose]);

  const [introDone, setIntroDone] = useState(false);
  useEffect(() => {
    setIntroDone(false);
  }, []);
  const LOGO_SIZE = 280;

  useEffect(() => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 200,
      useNativeDriver: true,
    }).start();
    return () => opacity.setValue(0);
  }, [opacity]);

  const submitData = () => {
    console.log(data);
    const payload = {
      username: data.username?.trim(),
      password: data.password || "",
    };
    if (!payload.username || !payload.password) return;

    console.log("DISPATCH loginRequest", payload);
    dispatch(loginRequest(payload));
  };

  const handleGoogleLogin = () => {
    dispatch(googleLoginRequest());
  };

  const handleFacebookLogin = () => {
    console.log("🔵 [FacebookLogin] click", { platform: Platform.OS });
    dispatch(facebookLoginRequest());
  };
  const webNoOutline =
    Platform.OS === "web" ? ({ outlineStyle: "none" } as any) : null;

  return (
    <>
      <SvaraModal
        visible
        onClose={onClose}
        closeIcon={showCloseIcon ? BtnSidebarClosePng : undefined}
        contentWrapperStyles={{
          paddingHorizontal: 0,
          paddingTop: 0,
          alignItems: "stretch",
          flexGrow: 1,
        }}
        containerStyles={{
          borderWidth: 0,
          borderColor: "transparent",
        }}
      >
        <View style={styles.stage}>
          <ImageBackground
            source={LoginBckgd}
            resizeMode="cover"
            style={{
              width: 300,
              minHeight: 600,
            }}
            imageStyle={{
              borderRadius: 18,
            }}
          >
            <View style={styles.container}>
              <View style={styles.introLayer}>
                <LoginLogoWeb />
              </View>
              {/* <View style={styles.introLayer}>
                <Image
                  source={LogoStatic}
                  resizeMode="contain"
                  style={{ width: LOGO_SIZE, height: LOGO_SIZE }}
                />
              </View> */}

              <View style={styles.content}>
                {/* <Text style={styles.title}>Login</Text> */}

                {/* Username */}
                <View style={styles.field}>
                  {/* <ImageBackground
                            source={InputField}
                            resizeMode="stretch"
                            style={styles.inputWrapper}
                          > */}
                  <Text style={styles.label}>EMAIL OR USERNAME</Text>
                  <TextInput
                    value={data.username}
                    onChangeText={(v) => onChange("username", v)}
                    placeholder={isFocused ? "" : "Username"}
                    placeholderTextColor="#94A3B8"
                    style={[
                      styles.input,
                      !!errors.username && styles.inputError,
                      webNoOutline,
                    ]}
                    autoCapitalize="none"
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    // editable={!authLoading}
                  />
                  {/* </ImageBackground> */}
                  <Text style={styles.helperText}>
                    {errors.username ?? "\u00a0"}
                  </Text>
                </View>

                {/* Password */}
                <View style={styles.field}>
                  {/* <View style={styles.passwordRow}> */}
                  {/* <ImageBackground
                              source={InputField}
                              resizeMode="stretch"
                              style={styles.inputWrapper}
                            > */}
                  <Text style={styles.label}>PASSWORD</Text>
                  <TextInput
                    value={data.password}
                    onChangeText={(v) => onChange("password", v)}
                    placeholder={isFocusedPass ? "" : "●●●●●●●●●●●"}
                    placeholderTextColor="#94A3B8"
                    onFocus={() => setIsFocusedPass(true)}
                    onBlur={() => setIsFocusedPass(false)}
                    secureTextEntry
                    style={[
                      styles.input,
                      // styles.passwordInput,
                      !!errors.password && styles.inputError,
                      webNoOutline,
                    ]}
                    autoCapitalize="none"
                    // editable={!authLoading}
                    onSubmitEditing={submitData}
                  />
                  {/* </ImageBackground> */}
                  {/* </View> */}
                  <Text style={styles.helperText}>
                    {errors.password ?? "\u00a0"}
                  </Text>
                  {authError && (
                    <Text style={styles.errorText}>{authError}</Text>
                  )}
                </View>

                {/* <View style={[styles.optionsRow]}>
                  <TouchableOpacity
                    style={styles.rememberRow}
                    // onPress={() => setRememberMe(!rememberMe)}
                  >
                    <View style={styles.checkbox}>
                   
                    </View>
                    <Text style={styles.rememberText}>Remember me</Text>
                  </TouchableOpacity>

                 
                  <TouchableOpacity>
                    <Text style={styles.forgotText}>Forgot Password?</Text>
                  </TouchableOpacity>
                </View> */}

                {/* Submit */}
                <View
                  style={{
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: 2,
                  }}
                >
                  <TouchableOpacity
                    onPress={submitData}
                    // disabled={authLoading}
                    style={authLoading && { opacity: 0.7 }}
                  >
                    <ImageBackground
                      source={Login}
                      resizeMode="contain"
                      style={{
                        width: 140,
                        height: 50,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text
                        style={[
                          {
                            color: "#FFFFFF",
                            fontWeight: "bold",
                            fontSize: 12,
                            textTransform: "uppercase",
                          },
                          i18n.language?.startsWith("fr") && { fontSize: 10 },
                        ]}
                      >
                        {t("T_SITE_LOGIN_TITLE")}
                      </Text>
                    </ImageBackground>
                  </TouchableOpacity>

                  {/* <TouchableOpacity onPress={handleFacebookLogin}>
                            <ImageBackground
                              source={FacebookLogin}
                              style={styles.socialButton}
                              resizeMode="stretch"
                            />
                          </TouchableOpacity> */}
                  <View style={{ flexDirection: "row" }}>
                    <TouchableOpacity onPress={handleGoogleLogin}>
                      <Image
                        source={GoogleButton}
                        style={styles.socialButton}
                        resizeMode="stretch"
                      />
                    </TouchableOpacity>
                    <TouchableOpacity
                      onPress={() => console.log("login with facebook")}
                    >
                      <Image
                        source={FacebookButton}
                        style={styles.socialButton}
                        resizeMode="stretch"
                      />
                    </TouchableOpacity>
                  </View>
                  <View
                    style={{
                      marginTop: 12,
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <LanguagePicker
                      value={langCode}
                      options={languages.map((l) => ({
                        code: l.code,
                        label: l.label,
                        flag: languageFlags[l.code],
                      }))}
                      caretIcon={LanguageCaret}
                      caretIconOpen={LanguageCaretUp}
                      buttonStyle={{
                        backgroundColor: "#4A2530",
                        height: 40,
                        width: 200,
                        borderColor: "#ab8b68",
                        borderWidth: 1,
                      }}
                      menuStyle={{
                        backgroundColor: "#211015",
                        borderColor: "#ab8b68",
                        borderWidth: 1,
                        marginBottom: 2,
                      }}
                      menuItemActiveStyle={{
                        backgroundColor: "#4A2530",
                        borderRadius: 4,

                        border: "1px solid #ab8b68",
                      }}
                      onChange={(code) => {
                        const lang = languages.find((l) => l.code === code);
                        if (lang)
                          dispatch(
                            i18nLoadRequest({
                              langId: lang.id,
                              langCode: lang.code,
                            }),
                          );
                      }}
                    />
                  </View>

                  {/* <View
                    style={{
                      marginTop: 12,
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        borderRadius: 8,
                        paddingHorizontal: 8,
                        paddingVertical: 6,
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {languages.map((l) => {
                        const flagSrc = languageFlags[l.code];
                        if (!flagSrc) return null;
                        const isActive = langCode === l.code;
                        return (
                          <TouchableOpacity
                            key={l.code}
                            onPress={() => handleChangeLanguage(l.code)}
                            style={{
                              paddingHorizontal: 4,
                              paddingVertical: 2,
                              borderRadius: 6,
                              opacity: isActive ? 1 : 0.8,
                            }}
                          >
                            <Image
                              source={flagSrc}
                              style={{ width: 32, height: 24 }}
                              resizeMode="contain"
                            />
                          </TouchableOpacity>
                        );
                      })}
                    </View>
                  </View> */}
                </View>
              </View>
            </View>
          </ImageBackground>
        </View>
      </SvaraModal>
    </>
  );
}

export default LoginModal;

const styles = StyleSheet.create({
  stage: {
    width: 300,
    minHeight: 600,
    borderRadius: 18,
    overflow: "hidden",
  },

  introLayer: {
    width: "100%",
    minHeight: 260,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0,0,0,0.0)",
  },
  overlay: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.7)",
  },
  modalBackground: {
    borderRadius: 10,
    borderWidth: 1,
    paddingTop: 0,
  },
  modalContainer: {
    // width: isPortrait ? 414 : 442,
    maxHeight: "100%",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#000",
    position: "relative",
    paddingTop: 0,
  },
  titleImage: {
    width: 340,
    height: 120,
    position: "absolute",
    top: -75,
    left: "50%",
    transform: [{ translateX: -170 }],
  },
  closeButton: {
    zIndex: 1,
    position: "absolute",
    width: 22,
    height: 22,
    top: 15,
    right: 17,
  },
  closeIcon: {
    width: 23,
    height: 15,
  },
  content: {
    alignItems: "center",
    marginTop: 20,
  },
  connectText: {
    color: "white",
    fontSize: 18,
    marginBottom: 20,
    fontWeight: "500",
  },
  buttonRow: {
    flexDirection: "row",
    gap: 15,
  },
  socialButton: {
    // width: 142,
    width: 56,
    height: 52,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 15,
  },
  container: {
    padding: 16,
    marginTop: 10,
  },
  title: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: "800",
    color: "#E5EAF2",
    marginBottom: 8,
  },
  label: {
    color: "#B7C1D1",
    fontSize: 13,
    marginBottom: 2,
    fontWeight: "600",
  },
  input: {
    color: "#E5EAF2",
    fontSize: 16,
    paddingHorizontal: 14,
    lineHeight: 20,
    paddingVertical: 0,
    textAlignVertical: "center",
    height: 32,
    borderRadius: 4,
    backgroundColor: "#4A2530",
  },
  inputError: {
    borderColor: "#ff6b6b",
  },
  helperText: {
    color: "#94A3B8",
    marginTop: 0,
  },
  passwordRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  passwordInput: {
    flex: 1,
    marginRight: 8,
  },
  eye: {
    fontSize: 18,
    color: "#B7C1D1",
    paddingHorizontal: 8,
    paddingVertical: 6,
  },
  //   submitBtn: {
  //     backgroundColor: "#6FEFFF",
  //     paddingVertical: 14,
  //     borderRadius: 10,
  //     alignItems: "center",
  //     marginTop: 12,
  //   },
  submitText: {
    color: "#0B1A2A",
    fontSize: 18,
    fontWeight: "800",
  },
  switchWrap: {
    flexDirection: "row",
    gap: 8,
    justifyContent: "center",
    marginTop: 10,
  },
  switchBtn: {
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#263447",
    backgroundColor: "transparent",
  },
  switchBtnActive: {
    backgroundColor: "#14253A",
    borderColor: "#6FEFFF",
  },
  switchText: { color: "#B7C1D1", fontWeight: "700" },
  switchTextActive: { color: "#E5EAF2" },
  socialBtn: {
    backgroundColor: "#1C2B3E",
    paddingVertical: 12,
    paddingHorizontal: 12,
    borderRadius: 10,
    flex: 1,
  },
  socialBtnText: {
    color: "#E5EAF2",
    textAlign: "center",
    fontWeight: "700",
    marginLeft: 30,
    textTransform: "uppercase",
    fontSize: 12,
  },
  inputWrapper: {
    width: 300,
    height: 60,
    // marginBottom: 20,
    justifyContent: "center",
    paddingHorizontal: 12,
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  overlayRoot: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },

  overlayBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0,0,0,0.8)",
  },

  backgroundImage: {
    // flex: 1,
    justifyContent: "center",
    alignItems: "center",
    width: 350,
    height: 500,
  },

  errorText: {
    color: "#ff6b6b",
    marginTop: 0,
    fontSize: 12,
    minHeight: 16,
  },

  field: {
    marginBottom: 0,
  },

  //  input: {
  //   color: "#E5EAF2",
  //   backgroundColor: "#48232f",
  //   fontSize: 16,
  //   lineHeight: 20,
  //   paddingVertical: 0,
  //   textAlignVertical: "center",
  //   height: 50,
  //   borderRadius: 6,
  //   width: 220,
  // },

  optionsRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 0,
    gap: 20,
  },

  rememberRow: {
    flexDirection: "row",
    alignItems: "center",
  },

  checkbox: {
    width: 18,
    height: 18,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#C6A6AE",
    marginRight: 8,
    justifyContent: "center",
    alignItems: "center",
  },

  checkboxChecked: {
    width: 10,
    height: 10,
    backgroundColor: "#E63950",
    borderRadius: 2,
  },

  rememberText: {
    color: "#C6A6AE",
    fontSize: 14,
  },

  forgotText: {
    color: "#E63950",
    fontSize: 14,
  },

  /* ---------- Toggle ---------- */
});
